/**
 * Generated bundle index. Do not edit.
 */

export {AuthService,SocialLoginModule,SocialUser,GoogleLoginProvider,FacebookLoginProvider,LinkedinLoginProvider,AuthServiceConfig} from './index';

export {BaseLoginProvider as ɵa} from './src/entities/base-login-provider';